// extracted by mini-css-extract-plugin
module.exports = {"tab":"styles_tab__XUyXI"};